
document.addEventListener('DOMContentLoaded', async function () {
  // Select eligible product cards on homepage and collection pages.
  const allCards = document.querySelectorAll(
    '.card-wrapper[data-base-price]'
  );

  const cache = new Map();

  function getProductTitle(card) {
    const titleElement = card.querySelector(
      '.card__heading a, .card__heading .full-unstyled-link'
    );

    return titleElement
      ? titleElement.textContent.trim()
      : '';
  }

  function isRingProduct(title) {
    return /\bring\b/i.test(title);
  }

  function formatPrice(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  async function getGloboDefaultAddon(url) {
    if (cache.has(url)) return cache.get(url);

    const promise = (async function () {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Product page fetch failed');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      let configText = '';

      for (const script of doc.querySelectorAll('script')) {
        const scriptText = script.textContent || '';

        if (
          scriptText.includes('window.GPOConfigs') &&
          scriptText.includes('productOptionSetMap')
        ) {
          configText = scriptText;
          break;
        }
      }

      if (!configText) return null;

      const optionStart = configText.search(
        /"id"\s*:\s*"dropdown-1"/
      );

      if (optionStart === -1) return null;

      const optionEnd = configText.indexOf(
        '"option_values"',
        optionStart
      );

      if (optionEnd === -1) return null;

      const optionSection = configText.slice(
        optionStart,
        optionEnd
      );

      if (
        !/"label"\s*:\s*"Carat Weight"/i.test(optionSection)
      ) {
        return null;
      }

      const optionMatch = configText.slice(optionStart).match(
        /"id"\s*:\s*"dropdown-1"[\s\S]*?"option_values"\s*:\s*\[([\s\S]*?)\]/
      );

      if (!optionMatch) return null;

      const values = Array.from(
        optionMatch[1].matchAll(
          /\{[\s\S]*?"price"\s*:\s*"([^"]+)"[\s\S]*?"value"\s*:\s*"([^"]+)"[\s\S]*?\}/g
        )
      );

      const defaultMatch = configText.slice(optionStart).match(
        /"id"\s*:\s*"dropdown-1"[\s\S]*?"default_value"\s*:\s*\[\s*"([^"]+)"/
      );

      const defaultValue = defaultMatch
        ? defaultMatch[1]
        : '1';

      const selected = values.find(function (match) {
        return match[2] === defaultValue;
      });

      if (!selected) return null;

      const addon = Number(selected[1]);

      if (!Number.isFinite(addon) || addon < 0) return null;

      return Math.round(addon * 100);
    })();

    cache.set(url, promise);

    try {
      return await promise;
    } catch (error) {
      cache.delete(url);
      throw error;
    }
  }

  for (const card of allCards) {
    const title = getProductTitle(card);

    // CRITICAL: Never modify non-ring products.
    if (!isRingProduct(title)) {
      console.log('[Ring price] Ignored non-ring product:', title);
      continue;
    }

    try {
      const link = card.querySelector(
        '.card__heading a, .card__heading .full-unstyled-link'
      );

      if (!link || !link.href) continue;

      console.log('[Ring price] Processing ring product:', title);

      const addonCents = await getGloboDefaultAddon(link.href);

      // Only update products with a confirmed Carat Weight add-on.
      if (addonCents === null || addonCents === undefined) {
        console.log(
          '[Ring price] Skipped — Carat Weight add-on not confirmed:',
          title
        );
        continue;
      }

      const basePrice = Number(card.dataset.basePrice);
      const comparePrice = Number(card.dataset.comparePrice || 0);
      const currency = card.dataset.currency || 'USD';

      if (!Number.isFinite(basePrice) || basePrice < 0) {
        console.warn('[Ring price] Invalid base price:', title);
        continue;
      }

      const totalPrice = basePrice + addonCents;
      const hasComparePrice = comparePrice > basePrice;

      const sale = card.querySelector(
        '.price__sale .price-item--sale'
      );

      const regular = card.querySelector(
        '.price__regular .price-item--regular'
      );

      const compareElement = card.querySelector(
        '.price__sale .price-item--regular'
      );

      if (hasComparePrice && sale) {
        sale.textContent = formatPrice(totalPrice, currency);

        if (compareElement) {
          compareElement.textContent = formatPrice(
            comparePrice + addonCents,
            currency
          );
        }
      } else if (regular) {
        regular.textContent = formatPrice(totalPrice, currency);
      } else if (sale) {
        sale.textContent = formatPrice(totalPrice, currency);
      } else {
        console.warn(
          '[Ring price] Price element not found:',
          title
        );
        continue;
      }

      console.log(
        '[Ring price] Updated:',
        title,
        formatPrice(totalPrice, currency)
      );
    } catch (error) {
      console.error(
        '[Ring price] Could not update:',
        title,
        error
      );
    }
  }
});
